<template>
  <footer ref="pagefoot">
    <div style="width: 100%; background-color: #053a7a">
      <div class="container bluebg">
        <div class="row text-center">
          <div class="col-12 col-lg-10 offset-lg-1">
            <hr style="border: 0" />
            <div class="row justify-content-center">
              <div
                class="col-lg-3 col-6 pt-3 text-lg-left text-center col-no-padding"
              >
                <a href="https://amcredit.com/why-american-credit"
                  ><h5 class="footer-text" style="font-size: 16px">
                    Why American Credit
                  </h5></a
                >
              </div>
              <div
                class="col-lg-1 col-6 pt-3 text-lg-left text-center col-no-padding"
              >
                <a href="https://amcredit.com/invest"
                  ><h5 class="footer-text" style="font-size: 16px">
                    Investor
                  </h5></a
                >
              </div>
              <div class="col-lg-2 col-6 pt-3 col-no-padding">
                <a href="https://amcredit.com/contact-us"
                  ><h5 class="footer-text" style="font-size: 16px">
                    Contact Us
                  </h5></a
                >
              </div>
              <div
                class="col-lg-3 offset-lg-1 col-6 pt-3 text-sm-right col-no-padding"
              >
                <a
                  href=""
                  onclick="document.body.scrollTop = 0; document.documentElement.scrollTop = 0; return false;"
                  ><h5 class="footer-text" style="font-size: 16px">
                    Back to Top
                  </h5></a
                >
              </div>
            </div>
            <hr style="border-top: 1px solid #31629e" />
            <div class="row text-left">
              <div class="col-12 col-lg-4 mobile-footer-margin">
                <ul>
                  <li>
                    <a href="https://amcredit.com">
                      <img
                        style="height: 72px; margin-bottom: 0.5rem"
                        :src="require('../../assets/imgs/logo_white.png')"
                        :srcset="
                          require('../../assets/imgs/logo-white-320w.png') +
                          ' 320w, ' +
                          require('../../assets/imgs/logo-white-640w.png') +
                          ' 640w'
                        "
                        alt="American Credit Logo White"
                        width="283"
                        height="72"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      class="footer-phone-number"
                      style="font-weight: 700"
                      href="tel:1855-904-0188"
                    >
                      <span>
                        <i
                          aria-hidden="true"
                          style="padding-right: 8px"
                          class="phone-icon fa fa-phone"
                        ></i
                        >855-904-0188
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="https://youtu.be/7v1c7cM19l0" target="_blank">
                      <img
                        style="height: 40px"
                        src="../../assets/imgs/american_credit_demo_video.png"
                        alt="american credit demo video"
                        width="125"
                        height="40"
                      />
                    </a>
                  </li>
                  <li style="display: none">
                    <a class="footer-text" href="https://amcredit.com/sitemap"> Sitemap </a>
                  </li>
                  <li>
                    <div class="row" style="margin-top: 0.5rem">
                      <div class="col-6">
                        <a
                          href="https://apps.apple.com/us/app/amcredit/id1489544972#?platform=iphone"
                          rel="nofollow"
                          target="_blank"
                        >
                          <img
                            style="height: 48px"
                            src="../../assets/imgs/app_store_black.png"
                            alt="American Credit mobile app in App Store"
                            width="162"
                            height="48"
                          />
                        </a>
                      </div>
                      <div class="col-6">
                        <a :href="AndroidApp" rel="nofollow" target="_blank">
                          <img
                            style="height: 48px"
                            src="../../assets/imgs/google_play_black.png"
                            alt="American Credit mobile app in Google Play"
                            width="164"
                            height="48"
                          />
                        </a>
                      </div>
                    </div>
                  </li>
                  <br/>
                  <li>
                    <a href="https://amcredit.com/equipment-financing-landing-page-1">
                      <span class="footer-text" style="font-size: 16px">
                        Landing Page to Equipment Finance
                      </span>
                    </a>
                  <li>
                    <a href="https://amcredit.com/working-capital-landing-page">
                      <span class="footer-text" style="font-size: 16px">
                        Landing Page for Working Capital
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="col-12 col-lg-8 mobile-footer-margin">
                <div class="row">
                  <div class="col-6 col-lg-3">
                    <h5 class="footer-title">SERVICES</h5>
                    <ul>
                      <li>
                        <a class="footer-text" href="https://amcredit.com/equipment-loan"
                          >Asset-Based Loans</a
                        >
                      </li>
                      <li>
                        <a class="footer-text" href="https://amcredit.com/invoice-factoring"
                          >Invoice/AR Factoring</a
                        >
                      </li>
                      <li>
                        <a class="footer-text" href="https://amcredit.com/vendor-financing">Vendor Financing</a>
                      </li>
                    </ul>
                  </div>
                  <div class="col-6 col-lg-3">
                    <h5 class="footer-title">RESOURCES</h5>
                    <ul>
                      <li>
                        <a
                          class="footer-text"
                          style="white-space: nowrap"
                          href="https://amcredit.com/loan-calculator"
                          >Loan Calculator</a
                        >
                      </li>
                      <li>
                        <a
                          class="footer-text"
                          style="white-space: nowrap"
                          href="https://amcredit.com/roi-calculator"
                          >ROI Calculator</a
                        >
                      </li>
                      <li><a class="footer-text" href="https://amcredit.com/faq">FAQs</a></li>
                      <li>
                        <a
                          class="footer-text"
                          href="https://amcredit.com/blog"
                          >Blog</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="col-6 col-lg-2">
                    <h5 class="footer-title">COMPANY</h5>
                    <ul>
                      <li>
                        <a class="footer-text" href="https://amcredit.com/partners">Partners</a>
                      </li>
                      <li>
                        <a class="footer-text" href="https://amcredit.com/careers">Careers</a>
                      </li>
                      <li>
                        <a class="footer-text" href="https://amcredit.com/about-us">About Us</a>
                      </li>
                      <li><a class="footer-text" href="https://amcredit.com/team">Team</a></li>
                    </ul>
                  </div>
                  <div class="col-6 col-lg-4">
                    <h5 class="footer-title">INDUSTRIES</h5>
                    <ul class="mb-3">
                      <li>
                        <a
                          class="footer-text"
                          href="https://amcredit.com/industries/commercial-truck-financing"
                          >Commercial Trucking Loans</a
                        >
                      </li>
                      <li>
                        <a
                          class="footer-text"
                          href="https://amcredit.com/industries/loans-for-contractors"
                          >Contracting Loans</a
                        >
                      </li>
                      <li>
                        <a
                          class="footer-text"
                          href="https://amcredit.com/industries/commercial-construction-loans"
                          >Construction Loans</a
                        >
                      </li>
                      <li>
                        <a
                          class="footer-text"
                          href="https://amcredit.com/industries/manufacturing-financing"
                          >Manufacturing Loans</a
                        >
                      </li>
                      <li>
                        <a
                          class="footer-text"
                          href="https://amcredit.com/industries/excavator-financing"
                          >Excavating Loans</a
                        >
                      </li>
                      <li>
                        <a
                          class="footer-text"
                          href="https://amcredit.com/industries/loans-for-restaurants"
                          >Restaurant Loans</a
                        >
                      </li>
                      <li>
                        <a
                          class="footer-text"
                          href="https://amcredit.com/industries/loans-for-landscapers"
                          >Landscaping Loans</a
                        >
                      </li>
                      <li>
                        <a
                          class="footer-text"
                          href="https://amcredit.com/industries/transportation-business-loans"
                          >Transportation Loans</a
                        >
                      </li>
                      <li>
                        <a
                          class="footer-text"
                          href="https://amcredit.com/industries/commercial-vehicle-loans"
                          >Commercial Auto Loans</a
                        >
                      </li>
                      <li>
                        <a
                          class="footer-text"
                          href="https://amcredit.com/industries/loans-for-farmers"
                          >Farming Loans</a
                        >
                      </li>
                      <li>
                        <a
                          class="footer-text"
                          href="https://amcredit.com/industries/commercial-real-estate-loans"
                          >Commercial Real Estate Loans</a
                        >
                      </li>
                      <li>
                        <a
                          class="footer-text"
                          href="https://amcredit.com/industries/working-capital-financing"
                          >Working Capital Financing</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="col-12 col-lg-7 mobile-footer-margin">
                <div
                  class="h7"
                  style="
                    margin-top: 8px;
                    font-family: Montserrat;
                    font-size: 14px;
                    font-weight: 500;
                  "
                >
                  <a href="https://amcredit.com/terms-of-use" class="footer-text">Terms of Uses</a>
                  |
                  <a href="https://amcredit.com/privacy-policy" class="footer-text"
                    >Privacy Policy</a
                  >
                  |
                  <a href="https://amcredit.com/communication-policy" class="footer-text"
                    >Consumer Communication Policy</a
                  >
                  |
                  <a href="https://amcredit.com/accessibility-policy" class="footer-text"
                    >Accessibility Policy</a
                  ><br />© 2023 American Credit<sup>®</sup>, Inc. All right
                  Reserved
                </div>
              </div>
              <div class="col-7 col-lg-3 pt-2 text-sm-center">
                <span class="d-inline-flex">
                  <a
                    id="bbblink"
                    class="eshzbus"
                    href="https://www.bbb.org/us/ca/palo-alto/profile/financial-services/american-credit-1216-1079741#bbbseal"
                    title="American Credit, Inc is a BBB Accredited Financial Service in Palo Alto, CA"
                    style="
                      display: block;
                      position: relative;
                      overflow: hidden;
                      width: 93px;
                      height: 35px;
                      margin: 0px;
                      padding: 0px;
                    "
                    rel="nofollow"
                    target="_blank"
                  >
                    <img
                      style="padding: 0px; border: none"
                      id="bbblinkimg"
                      src="https://seal-sanjose.bbb.org/logo/eshzbus/american-credit-1079741.png"
                      alt="American Credit, Inc is a BBB Accredited Financial Service in Palo Alto, CA"
                      width="93"
                      height="35"
                    />
                  </a>
                  &nbsp;
                  <img
                    src="../../assets/imgs/equal_housing.jpg"
                    alt="American Credit Equal Housing"
                    width="36"
                    height="35"
                  />
                  &nbsp;
                  <a href="https://www.uschamber.com"><img alt="U.S. Chamber of Commerce Member 2021" src="https://www.uschamber.com/assets/images/USCC_Webstickers_2022_234x75.png" title="U.S. Chamber of Commerce Member" height="35"></a>
                  &nbsp;
                </span>
              </div>
              <div class="col-5 col-lg-2 py-2 text-center">
                <a
                  href="https://www.facebook.com/amcredits"
                  rel="nofollow"
                  target="_blank"
                >
                  <img
                    style="width: 30px"
                    src="../../assets/imgs/fb.png"
                    alt="American Credit Facebook"
                    width="30"
                    height="30"
                  />
                </a>
                <a
                  href="https://americancredit.business.site/"
                  rel="nofollow"
                  target="_blank"
                >
                  <img
                    style="width: 30px"
                    src="../../assets/imgs/GooglePlus.png"
                    alt="American Credit GooglePlus"
                    width="30"
                    height="30"
                  />
                </a>
                <a
                  href="https://www.linkedin.com/company/amcredit"
                  rel="nofollow"
                  target="_blank"
                >
                  <img
                    style="width: 30px"
                    src="../../assets/imgs/LinkedIn.png"
                    alt="American Credit LinkedIn"
                    width="30"
                    height="30"
                  />
                </a>
                <a
                  href="https://twitter.com/amcredit_com"
                  rel="nofollow"
                  target="_blank"
                >
                  <img
                    style="width: 30px"
                    src="../../assets/imgs/twitter.png"
                    alt="American Credit Twitter"
                    width="30"
                    height="30"
                  />
                </a>
              </div>
            </div>
          </div>
          <div class="col-lg-1 col-md-1"></div>
        </div>
        <br />
      </div>
    </div>
    <div style="width: 100%; background-color: #00234d">
      <div class="container drakbluebg footer-tail">
        <br />
        <div class="text-center">
          <div class="row">
            <div
              class="col-12 h7"
              style="
                font-family: Montserrat;
                color: #759fd1;
                font-size: 12px;
                font-weight: 600;
                line-height: 24px;
              "
            >
              Certain financing may be made or arranged pursuant to California
              Financing Law - License No. 60DBO-78243 and NMLS ID: 1686352.
            </div>
          </div>
        </div>
        <div class="row">
          <div
            class="col-12 col-lg-10 offset-lg-1 h7 text-center"
            style="
              font-family: Montserrat;
              color: #759fd1;
              font-size: 12px;
              font-weight: 500;
              line-height: 21px;
            "
          >
            No monthly or maintenance fees. Wire Transfer Fees may apply.
          </div>
        </div>
        <div class="row">
          <div
            class="col-12 col-lg-10 offset-lg-1 h7 text-center"
            style="
              font-family: Montserrat;
              color: #759fd1;
              font-size: 12px;
              font-weight: 500;
              line-height: 21px;
            "
          >
            Terms and conditions apply. American Credit®, Inc is a Delaware
            registered company and qualified to do business in California.
            American Credit®, American Micro Credit®, and Amcredit® are
            registered trademarks of American Credit, Inc. The company logo is a
            registered logo of American Credit, Inc. All rights reserved.
          </div>
        </div>
        <br />
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import * as types from "../../vuex/types";
import _ from "lodash";
import api from "../../vuex/api/index";

export default {
  name: "Footer",
  data() {
    return {
      showFoot: true,
      msg: "",
      showbox: false,
    };
  },
  created() {
    if (this.$route.fullPath == "/") {
      this.showFoot = true;
    } else {
      this.showFoot = false;
      this.$refs.pagefoot.style.paddingTop = "0px";
      this.$refs.pagefoot.style.marginTop = "10px";
    }
  },
  watch: {
    $route(to, from) {
      if (to.fullPath == "/") {
        this.showFoot = true;
      } else {
        this.showFoot = false;

        this.$refs.pagefoot.style.paddingTop = "0px";
        this.$refs.pagefoot.style.marginTop = "10px";
      }
    },
  },
  methods: {
    closemail(bool) {
      this.showbox = bool;
    },

    // When the user clicks on the button, scroll to the top of the document
    topFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
};

// When the user clicks on the button, scroll to the top of the document
function topFunction() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}
</script>

<script type="text/javascript">
var bbbprotocol =
  "https:" == document.location.protocol ? "https://" : "http://";
(function () {
  var s = document.createElement("script");
  s.src =
    bbbprotocol +
    "seal-sanjose.bbb.org" +
    unescape("%2Flogo%2Famerican-credit-1079741.js");
  s.type = "text/javascript";
  s.async = true;
  var st = document.getElementsByTagName("script");
  st = st[st.length - 1];
  // console.log('st', st);
  var pt = st.parentNode;
  pt.insertBefore(s, st.nextSibling);
})();
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../assets/css/index.css";

.footer-title {
  font-family: Helvetica;
  color: #ffffff;
  font-size: 15px;
  font-weight: 700;
  line-height: 30px;
}

.footer-text {
  font-family: Montserrat;
  color: #abc6e8;
  font-size: 15px;
  font-weight: 500;
  line-height: 30px;
}
.footer-phone-number {
  color: white;
  font-size: 16px;
  font-weight: 700;
  line-height: 30px;
}

@media (max-width: 768px) {
  .col-no-padding {
    padding: 0;
  }
  .footer-text {
    line-height: 26px;
  }
  .footer-tail {
    // height: 320px;
  }
  .mobile-footer-margin {
    margin-top: 20px;
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// Footer.vue?5ce8ac5a